<PartListHistoryComponent
      [EquipId]="data.EquipId"
      [EquipDesc]="data.EquipDesc"
      [AvailableQuantity]="data.AvailableQuantity"
      [MachineName]="data.MachineName"
      [DivisionId]="data.DivisionId">
</PartListHistoryComponent>
